import { useState, useEffect, memo } from 'react';

interface IProps {
    className: string;
    src: string;
}

const AutoSizeImage = ({ className, src }: IProps) => {
    const [picture, setPicture] = useState<{ width: string; height: string; src: string }>();

    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
            if (img.width > img.height) {
                setPicture({ width: 'auto', height: '100%', src });
            } else {
                setPicture({ width: '100%', height: 'auto', src });
            }
        };
    }, []);

    return picture ? <img className={className} src={picture.src} width={picture.width} height={picture.height} /> : null;
};

export default memo(AutoSizeImage);
